import { isValidUuidV4 } from './isValidUuidV4.js';
import { randomUUID } from './randomUUID.js';

const uuid = {
    isValidUuidV4,
    randomUUID
};

export { uuid };
